import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsPageHeaderBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsPageHeaderBlockEntity
